import SimpleModalHeader from "./SimpleModalHeader.presenter";

export default SimpleModalHeader;
